import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const KebabMenuStyled = Styled.span`
	display: flex;
	justify-content:center;
	cursor:pointer;
	position :absolute;
	width: 16px;
	height:30px;
	right: 8px;
	border-radius: 4px;
	
	${({disabled}) => disabled && 'pointer-events: none;'}
	
	&:hover{
		background-color: rgba(0, 0, 0, 0.2);
	}
`;

const StyledSVG = Styled.svg`
	align-self:center;
`;

export const KebabMenuIcon = ({onClick, userpilot, cy, disabled}) => {
	return (
		<KebabMenuStyled onClick={onClick} data-userpilot={userpilot} data-cy={cy} disabled={disabled}>
			<StyledSVG xmlns="http://www.w3.org/2000/svg" height="18px" width="4px">
				<path d="M-.107143-.07242846h24V23.927572h-24z" fill="none" />
				<g transform="translate(-10 -3.0019999)" fill="#757575">
					<circle r="2" cy="5" cx="12" />
					<circle r="2" cy="12" cx="12" />
					<circle r="2" cy="19" cx="12" />
				</g>
			</StyledSVG>
		</KebabMenuStyled>
	);
};

KebabMenuIcon.propTypes = {
	onClick: PropTypes.func,
	userpilot: PropTypes.string,
	cy: PropTypes.string,
	disabled: PropTypes.bool,
};
